<template>
    <div class="p-3 row">
        <input-date-time class="col-12 col-md-3" :disabled="readonly" label="Data do ofício" v-model="form.data" ref="data" required type="date"/>
        <input-text class="col-12 col-md-3" :disabled="readonly" label="Versão XML" v-model="form.versao" ref="versao" required/>
        <input-text class="col-12 col-md-3" :disabled="readonly" label="Conceito" v-model="form.conceito" ref="conceito" required/>
        <input-select class="col-12 col-md-3" :disabled="readonly" :options="options.simnao" label="Projeto aprovado?" v-model="form.aprovado" ref="aprovado" required/>
        <div class="col-12 mb-2">
            <upload 
                id="annel3"
                tituloArquivo="Arrastar Arquivo" 
                selecioneArquivo="Selecionar Arquivo" 
                type=".*"
                
                @upload="(file, nomeArquivo)=> {                   
                    form.nomeArquivoAWS = nomeArquivo;
                    form.conteudoBase64 = file;
                }" />
        </div>   
        <div class="col-12" v-if="!readonly">
            <b-button v-if="permissao.c" variant="success" @click="$emit('salvar',form)">
                <i class="fa-solid fa-cloud-arrow-up mr-2"></i>
                Upload ofício
            </b-button>
        </div>     
        <div class="col-12 mt-3">
            <h6>Lista de avaliações recebidas</h6>
            <b-table head-variant="dark" hover :fields="table.fields" :items="itens">
                <template  #cell(actions)="data">
                    <div class="d-inline-flex">
                        <b-button variant="flat-primary" class="mr-2" @click="$emit('download', data.item.id)"><i class="fa-solid fa-cloud-arrow-down"></i></b-button>
                        <b-button variant="flat-danger" v-if="!readonly && permissao.d" class="mr-2" @click="$emit('deletar', data.item.id)"><i class="fas fa-trash"></i></b-button>
                    </div>
                </template>
            </b-table>
        </div>
    </div>
</template>
<script>
import InputDateTime from '@/components/inputs/InputDateTime';
import InputText from '@/components/inputs/InputText';
import InputSelect from '@/components/inputs/InputSelect';
import Upload from '@/components/upload/Upload';

import helpers from '@/common/utils/helpers';
import {FormMixin} from '@/common/mixins/FormMixin';
export default {
    name: "Annel2",
    mixins: [FormMixin],
    components: {
        InputDateTime,
        Upload,
        InputText,
        InputSelect
    },   
    props: {
        itens : {            
            default: () => []
        },
        projetoEditavel : {
            type : Boolean,
            default : false
        }
    },
    data: () => ({
        form : {
            arquivoObrigatorio : [
                {
                    nomeCampo : 'Ofício',
                    campo : 'conteudoBase64',
                }
            ],
            data: null,
            nomeArquivoAWS: "",
            versao: 0,
            conteudoBase64: null,
            projetoAprovado: null,
            conceito : null,
        },
        table : {
            fields : [
                { key: "nomeArquivoAWS", label:"Nome do arquivo"},
                { key: "versao", label:"Versão XML"},
                { key: "data", label:"Data de emissão",
                    formatter: (value) => helpers.formatarDataBr(value)
                },
                { key: "conceito", label:"Conceito"},
                { key: "aprovado", label:"Aprovado"},
                { key: "actions", label:"Ações"},
            ]
        },
        options : {
            simnao : [
                {
                    value: "S",
                    text: "Sim"
                },
                {
                    value: "N",
                    text: "Não"
                }
            ]
        }
    }),    
    watch: {
        itens: {
            handler: function(newValue) {
                this.form.versao = newValue.length ? newValue[newValue.length - 1].versao + 1 : 1;
            },
            deep: true,
            immediate: true
        }
    },
    
    computed :{
        permissao() {
            return this.$store.getters['app/retornaPermissao']('ProjetosPdObrigacoesAneel');
        },
        readonly :function(){
            return this.$route.name != 'projeto-detalhamento' || !this.projetoEditavel
        }
    }
}
</script>
<style lang="">
    
</style>